import reduxCrud from 'redux-crud';

const groupsActionCreators = reduxCrud.actionCreatorsFor('groups', {
  key: '_id',
});
const actionTypes = reduxCrud.actionTypesFor('groups', { key: '_id' });

export default groupsActionCreators;
export { actionTypes };
